<template>
  <div>
    <tc-v-btn
      color="accent"
      class="my-5 text-capitalize"
      x-large
      block
      :disabled="isDisabled"
      :aria-label="$t('directPayments.ach.checkoutButtonText')"
      tabindex="0"
      @click="$emit('click')"
      @keyup="$emit('keyup', $event)"
    >
      <v-icon>
        mdi-lock
      </v-icon>

      <span class="direct-payment-button-text px-3">
        {{ buttonText }}
      </span>
    </tc-v-btn>

    <div
      class="direct-payment-disclaimer text-left mb-0"
      v-html="$t('directPayments.checkoutDisclaimer')"
    />
  </div>
</template>

<script>
import { directPaymentType } from '@/components/direct-payments/direct-payment-constants'

export default {
  name: 'DirectPaymentButton',
  props: {
    paymentType: {
      type: String,
      default: null,
      validator: type => Object.keys(directPaymentType).includes(type)
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonText () {
      switch (this.paymentType) {
        case directPaymentType.ACH:
          return this.$t('directPayments.ach.checkoutButtonText')
        case directPaymentType.DEBIT:
          return this.$t('directPayments.debitCard.checkoutButtonText')
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
